import React from 'react';
import { Typography } from '@mui/material';
import { AppPermissionRequest } from '@Src/_basic/object/AppPermissionType';

interface Props {
  row: AppPermissionRequest;
}
export default function AccountColumnFormatter(props: Props) {
  const { row } = props;
  return <Typography variant="inherit">{row.account}</Typography>;
}
